import { render, staticRenderFns } from "./PropertySelect.vue?vue&type=template&id=b02d5a70&scoped=true"
import script from "./PropertySelect.vue?vue&type=script&lang=js"
export * from "./PropertySelect.vue?vue&type=script&lang=js"
import style0 from "./PropertySelect.vue?vue&type=style&index=0&id=b02d5a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02d5a70",
  null
  
)

export default component.exports